import { useState } from "react";

// ── Shop This Soft Beige Look products ──
const mainProducts = [
  {
    id: "sofa",
    name: "Soft Beige Sofa",
    description: "A comfortable neutral sofa that sets the tone for a calm and inviting living room.",
    priceRange: "Mid-range",
    buttonLabel: "Check Sofa Options",
    icon: "ri-sofa-line",
    tag: "Most Essential",
    affiliateUrl: "https://amzn.to/4vvGaQn",
  },
  {
    id: "rug",
    name: "Neutral Area Rug",
    description: "A soft textured rug that adds warmth and helps ground the entire space.",
    priceRange: "Budget to Mid-range",
    buttonLabel: "View Rug Options",
    icon: "ri-layout-grid-line",
    tag: "Bestseller",
    affiliateUrl: "https://amzn.to/4dx4Ykf",
  },
  {
    id: "curtains",
    name: "Linen Curtains",
    description: "Light, airy curtains that soften the room and support a relaxed natural look.",
    priceRange: "Budget to Mid-range",
    buttonLabel: "See Curtain Options",
    icon: "ri-layout-column-line",
    tag: "Easy Upgrade",
    affiliateUrl: "https://amzn.to/4tz8yPK",
  },
  {
    id: "table",
    name: "Light Wood Coffee Table",
    description: "A warm wood table that adds structure without making the room feel heavy.",
    priceRange: "Mid-range",
    buttonLabel: "Explore Coffee Tables",
    icon: "ri-table-line",
    tag: "Finishing Touch",
    affiliateUrl: "https://amzn.to/4tANU1D",
  },
];

// ── Similar Beige Sofas products ──
const beigeSofas = [
  {
    id: "linen-blend",
    name: "Linen Blend Beige Sofa",
    description: "A soft neutral sofa with a timeless shape that works beautifully in relaxed interiors.",
    priceRange: "Mid-range",
    buttonLabel: "Check Sofa Options",
    icon: "ri-sofa-line",
    tag: "Editor's Pick",
    affiliateUrl: "https://amzn.to/4sd5Qyh",
  },
  {
    id: "deep-seat-cream",
    name: "Deep Seat Cream Sofa",
    description: "A cozy oversized seating option for a lived-in but elevated soft beige look.",
    priceRange: "Mid-range to Splurge",
    buttonLabel: "View Similar Sofas",
    icon: "ri-sofa-line",
    tag: "Most Loved",
    affiliateUrl: "https://amzn.to/3PURN2K",
  },
  {
    id: "minimal-apartment",
    name: "Minimal Beige Apartment Sofa",
    description: "A clean-lined sofa that fits smaller living rooms while keeping the palette warm and airy.",
    priceRange: "Budget to Mid-range",
    buttonLabel: "See More Sofas",
    icon: "ri-sofa-line",
    tag: "Space Saver",
    affiliateUrl: "https://amzn.to/4bSOBgJ",
  },
];

// ── Similar Neutral Rugs products ──
const neutralRugs = [
  {
    id: "textured-ivory-rug",
    name: "Textured Ivory Area Rug",
    description: "A soft woven rug that brightens the room while keeping the palette natural and understated.",
    priceRange: "Budget to Mid-range",
    buttonLabel: "View Rug Options",
    icon: "ri-layout-grid-line",
    tag: "Natural Pick",
    affiliateUrl: "https://amzn.to/3POS4V2",
  },
  {
    id: "warm-beige-wool-rug",
    name: "Warm Beige Wool Rug",
    description: "A refined rug with gentle depth and texture for a more elevated living room finish.",
    priceRange: "Mid-range to Splurge",
    buttonLabel: "Explore Wool Rugs",
    icon: "ri-layout-grid-line",
    tag: "Editor's Choice",
    affiliateUrl: "https://amzn.to/48hSPfv",
  },
  {
    id: "flatweave-neutral-rug",
    name: "Flatweave Neutral Rug",
    description: "A lightweight neutral rug that works especially well in airy, minimalist spaces.",
    priceRange: "Budget",
    buttonLabel: "See Similar Rugs",
    icon: "ri-layout-grid-line",
    tag: "Most Versatile",
    affiliateUrl: "https://amzn.to/4mcCQFt",
  },
];

// ── Similar Linen Curtains products ──
const linenCurtains = [
  {
    id: "soft-white-linen",
    name: "Soft White Linen Curtains",
    description: "Filters natural light beautifully while giving the entire room a gentle, airy feel.",
    priceRange: "Budget to Mid-range",
    buttonLabel: "See Curtain Options",
    icon: "ri-layout-column-line",
    tag: "Natural Light",
    affiliateUrl: "https://amzn.to/3Q7Tiux",
  },
  {
    id: "natural-beige-sheer",
    name: "Natural Beige Sheer Curtains",
    description: "Keeps the room light and open while adding a soft, understated texture.",
    priceRange: "Budget",
    buttonLabel: "View Sheer Curtains",
    icon: "ri-layout-column-line",
    tag: "Airy Pick",
    affiliateUrl: "https://amzn.to/4ds3hEI",
  },
  {
    id: "linen-blend-drape",
    name: "Premium Linen Blend Drape",
    description: "A refined curtain option for a more polished and complete room finish.",
    priceRange: "Mid-range to Splurge",
    buttonLabel: "Explore Premium Curtains",
    icon: "ri-layout-column-line",
    tag: "Editor's Pick",
    affiliateUrl: "https://amzn.to/4cdAb9V",
  },
];

// ── Similar Light Wood Coffee Tables products ──
const coffeeTablesProducts = [
  {
    id: "round-oak-table",
    name: "Round Oak Coffee Table",
    description: "A softly shaped table that blends naturally into the space while keeping the mood calm.",
    priceRange: "Mid-range",
    buttonLabel: "View This Table",
    icon: "ri-table-line",
    tag: "Most Natural",
    affiliateUrl: "https://amzn.to/4t1hFJ8",
  },
  {
    id: "minimal-light-wood",
    name: "Minimal Light Wood Table",
    description: "A clean, simple form that suits airy and open living rooms without adding visual weight.",
    priceRange: "Budget to Mid-range",
    buttonLabel: "See Similar Tables",
    icon: "ri-table-line",
    tag: "Clean Lines",
    affiliateUrl: "https://amzn.to/4e3bAqG",
  },
  {
    id: "ash-sculptural-table",
    name: "Sculptural Ash Wood Table",
    description: "Adds a quiet presence to the room through natural material and considered form.",
    priceRange: "Splurge",
    buttonLabel: "Explore Premium Tables",
    icon: "ri-table-line",
    tag: "Editor's Pick",
    affiliateUrl: "https://amzn.to/41gLVn4",
  },
];

// ── Budget Version Under $500 products ──
const budgetProducts = [
  {
    id: "budget-rug",
    name: "Beige Table Lamp",
    description: "Adds soft texture and warmth to the space while keeping costs low.",
    priceRange: "Under $150",
    buttonLabel: "View Budget Lamps",
    icon: "ri-lightbulb-line",
    tag: "Best Value",
    affiliateUrl: "https://amzn.to/3O1OR3W",
  },
  {
    id: "budget-curtains",
    name: "Simple Linen-Look Curtains",
    description: "Keeps the room feeling light and soft without stretching the budget.",
    priceRange: "Under $80",
    buttonLabel: "See Curtain Options",
    icon: "ri-layout-column-line",
    tag: "Light & Airy",
    affiliateUrl: "",
  },
  {
    id: "budget-side-table",
    name: "Minimal Wooden Side Table",
    description: "Brings in a natural wood feel without making the space feel heavy or cluttered.",
    priceRange: "Under $120",
    buttonLabel: "View Side Tables",
    icon: "ri-table-line",
    tag: "Natural Touch",
    affiliateUrl: "",
  },
  {
    id: "budget-cushions",
    name: "Neutral Tone Cushions",
    description: "An easy, low-cost way to add softness and cohesion to the overall look.",
    priceRange: "Under $50",
    buttonLabel: "View Cushion Options",
    icon: "ri-heart-line",
    tag: "Easy Finish",
    affiliateUrl: "",
  },
];

// ── Elevated Version $500–$2,000 products ──
const elevatedProducts = [
  {
    id: "elevated-sofa",
    name: "Quality Beige Sofa",
    description: "A well-crafted sofa that anchors the room with quiet confidence and lasting comfort.",
    priceRange: "$900–$1,600",
    buttonLabel: "View Sofa Options",
    icon: "ri-sofa-line",
    tag: "Anchor Piece",
    affiliateUrl: "",
  },
  {
    id: "elevated-rug",
    name: "Refined Neutral Rug",
    description: "A rug with better underfoot feel and natural character that elevates the whole room.",
    priceRange: "$300–$700",
    buttonLabel: "View Rug Options",
    icon: "ri-layout-grid-line",
    tag: "Refined Texture",
    affiliateUrl: "",
  },
  {
    id: "elevated-table",
    name: "Solid Wood Coffee Table",
    description: "Uses the warmth of real wood to gently anchor the space without overpowering it.",
    priceRange: "$400–$900",
    buttonLabel: "View Table Options",
    icon: "ri-table-line",
    tag: "Natural Craft",
    affiliateUrl: "",
  },
  {
    id: "elevated-curtains",
    name: "Linen Blend Curtain Set",
    description: "Brings a more finished, cohesive quality to the windows and the room as a whole.",
    priceRange: "$150–$350",
    buttonLabel: "View Curtain Options",
    icon: "ri-layout-column-line",
    tag: "Finishing Layer",
    affiliateUrl: "",
  },
];

// ── Splurge Picks for a Luxury Look products ──
const splurgeProducts = [
  {
    id: "splurge-sofa",
    name: "Curved Luxury Beige Sofa",
    description: "A sculptural sofa with premium upholstery that becomes the quiet centerpiece of the room.",
    priceRange: "$2,000+",
    buttonLabel: "View Luxury Sofas",
    icon: "ri-sofa-line",
    tag: "Statement Piece",
    affiliateUrl: "",
  },
  {
    id: "splurge-rug",
    name: "Designer Wool Rug",
    description: "Rich in texture and feel, this rug adds understated luxury without demanding attention.",
    priceRange: "$1,000+",
    buttonLabel: "View Luxury Rugs",
    icon: "ri-layout-grid-line",
    tag: "Artisan Craft",
    affiliateUrl: "",
  },
  {
    id: "splurge-table",
    name: "Statement Oak Coffee Table",
    description: "Brings warmth and refined presence through natural material and considered craftsmanship.",
    priceRange: "$1,200+",
    buttonLabel: "View Premium Tables",
    icon: "ri-table-line",
    tag: "Sculptural",
    affiliateUrl: "",
  },
  {
    id: "splurge-curtains",
    name: "High-Quality Linen Drape",
    description: "Softens the entire room and adds a polished, high-end finish to the window treatment.",
    priceRange: "$500+",
    buttonLabel: "View Premium Curtains",
    icon: "ri-layout-column-line",
    tag: "Refined Drape",
    affiliateUrl: "",
  },
];

// ── Beige Living Room Look for Less products ──
const lookForLessProducts = [
  {
    id: "less-sofa",
    name: "Affordable Beige Sofa Alternative",
    description: "A budget-friendly option that keeps the same soft neutral tone and relaxed feel.",
    priceRange: "Budget to Mid-range",
    buttonLabel: "View Affordable Sofas",
    icon: "ri-sofa-line",
    tag: "Smart Pick",
    affiliateUrl: "",
  },
  {
    id: "less-rug",
    name: "Affordable Neutral Rug Alternative",
    description: "Maintains the cohesive, grounded look of the room without the higher price tag.",
    priceRange: "Budget",
    buttonLabel: "View Affordable Rugs",
    icon: "ri-layout-grid-line",
    tag: "Best Value",
    affiliateUrl: "",
  },
  {
    id: "less-table",
    name: "Affordable Wood Table Alternative",
    description: "Brings in a natural wood feel at a lower price point without compromising the aesthetic.",
    priceRange: "Budget to Mid-range",
    buttonLabel: "View Affordable Tables",
    icon: "ri-table-line",
    tag: "Natural Feel",
    affiliateUrl: "",
  },
  {
    id: "less-curtains",
    name: "Affordable Curtain Alternative",
    description: "Keeps the window treatment light and soft while staying well within budget.",
    priceRange: "Budget",
    buttonLabel: "View Affordable Curtains",
    icon: "ri-layout-column-line",
    tag: "Easy Win",
    affiliateUrl: "",
  },
];

function ProductCard({
  name,
  description,
  priceRange,
  buttonLabel,
  icon,
  tag,
  affiliateUrl,
}: {
  name: string;
  description: string;
  priceRange: string;
  buttonLabel: string;
  icon: string;
  tag: string;
  affiliateUrl: string;
}) {
  const [hovered, setHovered] = useState(false);
  const hasLink = affiliateUrl.trim().length > 0;

  return (
    <div
      className="group border border-[#EDE6DA] rounded-xl p-6 bg-[#FDFAF5] hover:border-[#C8BAA8] transition-all duration-300 flex flex-col gap-4"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {/* Top row: icon + tag */}
      <div className="flex items-start justify-between">
        <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#F5F1E8]">
          <i className={`${icon} text-[#8B8378] text-base`} />
        </div>
        <span
          className="text-[#B5A898] text-[9px] tracking-[0.35em] uppercase border border-[#EDE6DA] px-2.5 py-1 rounded-full"
          style={{ fontFamily: "'Inter', sans-serif" }}
        >
          {tag}
        </span>
      </div>

      {/* Product name */}
      <h3
        className="text-[#2C2825] text-lg leading-snug"
        style={{ fontFamily: "'Playfair Display', serif", fontWeight: 500 }}
      >
        {name}
      </h3>

      {/* Description */}
      <p
        className="text-[#8B8378] text-sm leading-relaxed flex-1"
        style={{ fontFamily: "'Inter', sans-serif", fontWeight: 300 }}
      >
        {description}
      </p>

      {/* Price */}
      <div className="flex items-center gap-2">
        <span
          className="text-[#B5A898] text-[10px] tracking-[0.3em] uppercase"
          style={{ fontFamily: "'Inter', sans-serif" }}
        >
          Price
        </span>
        <span className="w-4 h-px bg-[#EDE6DA]" />
        <span
          className="text-[#6B5E53] text-xs"
          style={{ fontFamily: "'Inter', sans-serif", fontWeight: 400 }}
        >
          {priceRange}
        </span>
      </div>

      {/* CTA button / link */}
      {hasLink ? (
        <a
          href={affiliateUrl}
          target="_blank"
          rel="nofollow noopener noreferrer"
          className="mt-1 self-start inline-flex items-center gap-2 border border-[#C8BAA8] text-[#6B5E53] px-5 py-2.5 rounded-full text-xs tracking-[0.14em] hover:bg-[#2C2825] hover:text-white hover:border-[#2C2825] transition-all duration-300 cursor-pointer whitespace-nowrap"
          style={{ fontFamily: "'Inter', sans-serif" }}
        >
          {buttonLabel}
          <span className="w-3 h-3 flex items-center justify-center">
            <i
              className={`ri-arrow-right-line text-[10px] transition-transform duration-200 ${hovered ? "translate-x-0.5" : ""}`}
            />
          </span>
        </a>
      ) : (
        <div
          className="mt-1 self-start inline-flex items-center gap-2 border border-[#EDE6DA] text-[#C8BAA8] px-5 py-2.5 rounded-full text-xs tracking-[0.14em] whitespace-nowrap select-none"
          style={{ fontFamily: "'Inter', sans-serif" }}
          title="Link coming soon"
        >
          {buttonLabel}
          <span className="w-3 h-3 flex items-center justify-center">
            <i className="ri-time-line text-[10px]" />
          </span>
        </div>
      )}
    </div>
  );
}

function SectionDivider({ label }: { label: string }) {
  return (
    <div className="flex items-center gap-5 mb-10">
      <div className="flex-1 h-px bg-[#EDE6DA]" />
      <p
        className="text-[#B5A898] text-[10px] tracking-[0.45em] uppercase flex-shrink-0"
        style={{ fontFamily: "'Inter', sans-serif" }}
      >
        {label}
      </p>
      <div className="flex-1 h-px bg-[#EDE6DA]" />
    </div>
  );
}

function ProductGrid({
  products,
  cols = 2,
}: {
  products: typeof mainProducts;
  cols?: 2 | 3;
}) {
  return (
    <div className={`grid grid-cols-1 ${cols === 3 ? "sm:grid-cols-3" : "sm:grid-cols-2"} gap-5`}>
      {products.map((p) => (
        <ProductCard
          key={p.id}
          name={p.name}
          description={p.description}
          priceRange={p.priceRange}
          buttonLabel={p.buttonLabel}
          icon={p.icon}
          tag={p.tag}
          affiliateUrl={p.affiliateUrl}
        />
      ))}
    </div>
  );
}

export default function ArticleShopSection() {
  return (
    <section className="max-w-2xl mx-auto px-4 md:px-0 py-4 mb-16">

      {/* ── Shop This Soft Beige Look ── */}
      <div id="shop-this-look" className="mb-16">
        <p className="text-[#B5A898] text-[10px] tracking-[0.45em] uppercase mb-3" style={{ fontFamily: "'Inter', sans-serif" }}>
          Shopping Guide
        </p>
        <h2 className="text-[#2C2825] text-2xl md:text-3xl leading-snug mb-6" style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}>
          Shop This Soft Beige Look
        </h2>
        <p className="text-[#6B5E53] text-sm md:text-base leading-relaxed mb-2" style={{ fontFamily: "'Inter', sans-serif", fontWeight: 300 }}>
          Recreating a soft beige living room starts with a few warm, layered essentials.
          Focus on pieces with natural textures, light wood tones, soft upholstery, and a calm neutral palette.
        </p>
        <div className="w-12 h-px bg-[#C8BAA8] mb-10" />
        <ProductGrid products={mainProducts} cols={2} />
      </div>

      {/* ── Similar Beige Sofas ── */}
      <div id="similar-beige-sofas" className="mb-16">
        <p className="text-[#B5A898] text-[10px] tracking-[0.45em] uppercase mb-3" style={{ fontFamily: "'Inter', sans-serif" }}>
          Sofa Edit
        </p>
        <h2 className="text-[#2C2825] text-2xl md:text-3xl leading-snug mb-6" style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}>
          Similar Beige Sofas
        </h2>
        <p className="text-[#6B5E53] text-sm md:text-base leading-relaxed mb-2" style={{ fontFamily: "'Inter', sans-serif", fontWeight: 300 }}>
          A beige sofa is often the anchor piece in a calm living room. Look for soft upholstery,
          rounded silhouettes, and warm neutral tones that feel effortless and inviting.
        </p>
        <div className="w-12 h-px bg-[#C8BAA8] mb-10" />
        <ProductGrid products={beigeSofas} cols={3} />
      </div>

      {/* ── Similar Neutral Rugs ── */}
      <div id="similar-neutral-rugs" className="mb-16">
        <p className="text-[#B5A898] text-[10px] tracking-[0.45em] uppercase mb-3" style={{ fontFamily: "'Inter', sans-serif" }}>
          Rug Edit
        </p>
        <h2 className="text-[#2C2825] text-2xl md:text-3xl leading-snug mb-6" style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}>
          Similar Neutral Rugs
        </h2>
        <p className="text-[#6B5E53] text-sm md:text-base leading-relaxed mb-2" style={{ fontFamily: "'Inter', sans-serif", fontWeight: 300 }}>
          A neutral rug adds warmth, softness, and visual balance to a beige living room.
          The best options have subtle texture and low-contrast tones that support a quiet, layered look.
        </p>
        <div className="w-12 h-px bg-[#C8BAA8] mb-10" />
        <ProductGrid products={neutralRugs} cols={3} />
      </div>

      {/* ── Similar Linen Curtains ── */}
      <div id="similar-linen-curtains" className="mb-16">
        <p className="text-[#B5A898] text-[10px] tracking-[0.45em] uppercase mb-3" style={{ fontFamily: "'Inter', sans-serif" }}>
          Curtain Edit
        </p>
        <h2 className="text-[#2C2825] text-2xl md:text-3xl leading-snug mb-6" style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}>
          Similar Linen Curtains
        </h2>
        <p className="text-[#6B5E53] text-sm md:text-base leading-relaxed mb-2" style={{ fontFamily: "'Inter', sans-serif", fontWeight: 300 }}>
          Linen curtains soften incoming light and bring a natural, unhurried quality to the room.
          Look for off-white to sand-beige tones in a lightweight weave to match this calm aesthetic.
        </p>
        <div className="w-12 h-px bg-[#C8BAA8] mb-10" />
        <ProductGrid products={linenCurtains} cols={3} />
      </div>

      {/* ── Similar Light Wood Coffee Tables ── */}
      <div id="similar-coffee-tables" className="mb-16">
        <p className="text-[#B5A898] text-[10px] tracking-[0.45em] uppercase mb-3" style={{ fontFamily: "'Inter', sans-serif" }}>
          Table Edit
        </p>
        <h2 className="text-[#2C2825] text-2xl md:text-3xl leading-snug mb-6" style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}>
          Similar Light Wood Coffee Tables
        </h2>
        <p className="text-[#6B5E53] text-sm md:text-base leading-relaxed mb-2" style={{ fontFamily: "'Inter', sans-serif", fontWeight: 300 }}>
          A light wood coffee table adds warmth and natural dimension to a soft beige interior.
          Rounded forms and visible grain work especially well for keeping the mood gentle and grounded.
        </p>
        <div className="w-12 h-px bg-[#C8BAA8] mb-10" />
        <ProductGrid products={coffeeTablesProducts} cols={3} />
      </div>

      {/* ── Budget tiers cluster ── */}
      <SectionDivider label="By Budget" />

      {/* ── Budget Version Under $500 ── */}
      <div id="budget-under-500" className="mb-16">
        <p className="text-[#B5A898] text-[10px] tracking-[0.45em] uppercase mb-3" style={{ fontFamily: "'Inter', sans-serif" }}>
          Budget
        </p>
        <h2 className="text-[#2C2825] text-2xl md:text-3xl leading-snug mb-6" style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}>
          Budget Version Under $500
        </h2>
        <p className="text-[#6B5E53] text-sm md:text-base leading-relaxed mb-2" style={{ fontFamily: "'Inter', sans-serif", fontWeight: 300 }}>
          A calm beige living room is very achievable without a large budget.
          By keeping the colour palette tight and choosing pieces with soft textures and simple forms,
          you can create a cohesive and inviting space for well under $500.
        </p>
        <div className="w-12 h-px bg-[#C8BAA8] mb-10" />
        <ProductGrid products={budgetProducts} cols={2} />
      </div>

      {/* ── Elevated Version $500–$2,000 ── */}
      <div id="elevated-500-2000" className="mb-16">
        <p className="text-[#B5A898] text-[10px] tracking-[0.45em] uppercase mb-3" style={{ fontFamily: "'Inter', sans-serif" }}>
          Mid-Range
        </p>
        <h2 className="text-[#2C2825] text-2xl md:text-3xl leading-snug mb-6" style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}>
          Elevated Version $500–$2,000
        </h2>
        <p className="text-[#6B5E53] text-sm md:text-base leading-relaxed mb-2" style={{ fontFamily: "'Inter', sans-serif", fontWeight: 300 }}>
          In this price range, material quality and finish improve noticeably,
          making it easier to achieve a more complete and considered look.
          These are realistic, well-balanced picks for a calm and refined beige interior.
        </p>
        <div className="w-12 h-px bg-[#C8BAA8] mb-10" />
        <ProductGrid products={elevatedProducts} cols={2} />
      </div>

      {/* ── Splurge Picks for a Luxury Look ── */}
      <div id="splurge-luxury" className="mb-16">
        <p className="text-[#B5A898] text-[10px] tracking-[0.45em] uppercase mb-3" style={{ fontFamily: "'Inter', sans-serif" }}>
          Luxury
        </p>
        <h2 className="text-[#2C2825] text-2xl md:text-3xl leading-snug mb-6" style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}>
          Splurge Picks for a Luxury Look
        </h2>
        <p className="text-[#6B5E53] text-sm md:text-base leading-relaxed mb-2" style={{ fontFamily: "'Inter', sans-serif", fontWeight: 300 }}>
          For a more elevated result, focus on pieces with exceptional material quality and refined silhouettes.
          The goal is quiet luxury — softness and elegance over statement or excess.
        </p>
        <div className="w-12 h-px bg-[#C8BAA8] mb-10" />
        <ProductGrid products={splurgeProducts} cols={2} />
      </div>

      {/* ── Beige Living Room Look for Less ── */}
      <div id="look-for-less" className="mb-16">
        <p className="text-[#B5A898] text-[10px] tracking-[0.45em] uppercase mb-3" style={{ fontFamily: "'Inter', sans-serif" }}>
          Value Edit
        </p>
        <h2 className="text-[#2C2825] text-2xl md:text-3xl leading-snug mb-6" style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}>
          Beige Living Room Look for Less
        </h2>
        <p className="text-[#6B5E53] text-sm md:text-base leading-relaxed mb-2" style={{ fontFamily: "'Inter', sans-serif", fontWeight: 300 }}>
          A calm beige living room does not require expensive furniture to feel right.
          What matters most is keeping the colour palette focused, the textures soft,
          and the shapes simple — all of which are very achievable on a smaller budget.
        </p>
        <div className="w-12 h-px bg-[#C8BAA8] mb-10" />
        <ProductGrid products={lookForLessProducts} cols={2} />
      </div>
    </section>
  );
}
